<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="Waterkotte_EcoPack_2d02"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import Waterkotte_EcoPack_2d02 from '@/device-products/Waterkotte_EcoPack_2d02.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: Waterkotte_EcoPack_2d02, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
